import { Platform, Orientation } from "consts";

export const ListTextFontWeight = {
  [Platform.AND]: {
    [Orientation.LANDSCAPE]: "800",
    [Orientation.PORTRAIT]: "800",
  },
};

export const ListTextFontSize = {
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "22",
    [Orientation.PORTRAIT]: "22",
  },
};

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "50%",
    [Orientation.LANDSCAPE]: "50%",
  },
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "70%",
    [Orientation.LANDSCAPE]: "60%",
  },
};

export const FeedbackButtonWidth = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "50%",
    [Orientation.LANDSCAPE]: "26%",
  },
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: width => (width - 220) / 2,
    [Orientation.LANDSCAPE]: width => (width - 325) / 3,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: width => (width - 60) / 2,
    [Orientation.LANDSCAPE]: width => (width - 120) / 2,
  },
};
